import { FC, Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import SiteLayout from '../components/SiteLayout';

const Home = lazy(() => import('../pages/Home/Home'));

const Work = lazy(() => import('../pages/Work/Work'));

const CaseStudy = lazy(() => import('../pages/CaseStudy/CaseStudy'));

const CVPage = lazy(() => import('../pages/CVPage/CVPage'));

const NotFound = lazy(() => import('../pages/NotFound/NotFound'));

const Router: FC = () => {
    return (
        <Suspense fallback={<div className="site-loading" aria-busy="true" />}>
            <Routes>
                {/* Unauthenticated routes */}
                {/* Nocturne pages share the site shell (header, footer, motion). */}
                <Route element={<SiteLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/work" element={<Work />} />
                    <Route path="/work/:slug" element={<CaseStudy />} />
                    <Route path="/curriculum-vitae" element={<CVPage />} />
                    {/* Keep the known routes in step with public/staticwebapp.config.json and the sitemap's
                        STATIC_PATHS, so they're served with a 200 rather than the host's 404. */}
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </Suspense>
    );
};

export default Router;
